export default __webpack_public_path__ + "static/media/jira.1b79d9d0.svg";